import { DisclosureStatusEnum } from '@vivli/features/disclosures/infrastructure/enum';
import moment from 'moment/moment';
import { IDisclosure } from '@vivli/features/disclosures/infrastructure/interface';

export const useDisclosureStatus = () => {
    return (disclosure: IDisclosure) => {
        switch (disclosure.status) {
            case DisclosureStatusEnum.None:
                return 'None';
            case DisclosureStatusEnum.Draft:
                return 'Draft (30-day review period has not been initiated)';
            case DisclosureStatusEnum.ThirtyDayReview:
                const currentDate = moment().utc(false);
                const endDate = moment(disclosure.reviewEndDate).utc(false);
                const daysTillEndDate = endDate.diff(currentDate, 'days') + 1;
                const isPluralDays = daysTillEndDate > 1;
                const reviewDaysString = !isNaN(daysTillEndDate) ? `, ${daysTillEndDate} day${isPluralDays ? 's' : ''} remaining` : '';

                return `In Review (30-day review started${reviewDaysString})`;
            case DisclosureStatusEnum.ReviewComplete:
                return 'Review Complete (30-Day review completed)';
            case DisclosureStatusEnum.SubmittedToPublisher:
                return 'Submitted to Publisher';
            case DisclosureStatusEnum.Published:
                return 'Published';
            case DisclosureStatusEnum.NotPublished:
                return 'Not Published';
            case DisclosureStatusEnum.Withdrawn:
                return 'Withdrawn';
        }
    };
};
